<template>
    <div class="row">
        <div class="col-md-12 mb-4" v-show="!canReply">
            To be able to reply to comments through Guestflip's web application, you have to connect the instagram page that is related to the following instagram account: <strong>{{profileIDs[0]}}</strong>
                <br>
                <a class="btn btn-primary pull-right" v-bind:href="'/settings/hotels/' + currentTeam + '#/social'">Connect facebook page</a>
        </div>
        <div class="col-md-12">
            <div class="table-responsive posts-table">
                <table class="table">
                    <thead>
                        <th>Post</th>
                        <th>User</th>
                        <th>Comment</th>
                        <th>Date</th>
                        <th>Actions</th>
                    </thead>
                    <tbody>
                        <tr v-for="comment in comments">
                            <td>
                                <img class="img-responsive" style="max-width: 100px; max-height: 100px;" :src="comment.imageUrl"/>
                            </td>
                            <td class="align-middle">
                                <a target="_blank" v-bind:href="'https://www.instagram.com/' + comment.username">@{{comment.username}}</a>
                            </td>
                            <td class="align-middle">{{comment.textComment}}</td>
                            <td class="align-middle">{{formatDate(comment.dateCreated)}}</td>
                            <td class="align-middle">
                                <button class="btn btn-primary" v-on:click="showReplyModal(comment)" v-if="!comment.replied" v-show="canReply">Reply</button>
                                <a target="_blank" class="btn btn-warning btn-gradient-warning" :href="'https://instagram.com/p/' + comment.postShortcode" v-if="!comment.replied" v-show="!canReply" data-toggle="tooltip" data-placement="top" title="To reply without redirecting to instagram, please connect an facebook / instagram page">
                                    <i class="fas fa-exclamation-triangle"></i> Reply
                                </a>
                                <span class="text text-success" v-if="comment.replied">Replied</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-md-12 mt-3">
                <pagination
                    :current_page="page"
                    :last_page="lastPage"
                    :num_items="20"
                    :num_total="total">
                </pagination>
            </div>
        </div>
        <div class="modal" id="modal-update-announcement" tabindex="-1" role="dialog" ref="instagram_comment_reply_modal">
            <div class="modal-dialog gf">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Reply to comment
                        </h5>
                    </div>

                    <div class="modal-body">
                        <form role="form">
                            <div class="form-group">
                                <strong>Posted by</strong>
                                <br>
                                <a target="_blank" v-bind:href="'https://www.instagram.com/' + currentComment.username">@{{currentComment.username}}</a>
                            </div>

                            <div class="form-group">
                                <strong>Comment</strong>
                                <br>
                                {{currentComment.textComment}}
                            </div>

                            <div class="form-group">
                                <textarea v-model="commentReply" class="form-control" placeholder="Write your reply here"/>
                            </div>
                        </form>
                    </div>

                    <!-- Modal Actions -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">{{__('Close')}}</button>
                        <button type="button" class="btn btn-primary" v-on:click="reply(currentComment.id, commentReply)" v-bind:disabled="postingReply">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="postingReply"></span>
                            <span>{{__('Reply')}}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import InstagramService from '../../services/instagram-service'
    import BarChart from '../charts/bar-chart'
    import InstagramMixin from "./InstagramMixin";

    export default {
        components: { BarChart },
        mixins: [InstagramMixin],
        data() {
            return {
                currentTeam: Spark.state.currentTeam.id,
                canReply: false,
                postingReply: false,
                commentReply: '',
                currentComment: {},
                comments: [],
                page: 1,
                lastPage: null,
                total: null,
            }
        },
        computed: {
        },
        methods: {
            showReplyModal(comment) {
                this.currentComment = comment
                $(this.$refs.instagram_comment_reply_modal).modal()
            },
            async reply(id, reply) {
                this.postingReply = true
                await InstagramService.comments.reply({ id, message: reply })

                setTimeout(() => {
                    this.postingReply = false
                    $(this.$refs.instagram_comment_reply_modal).modal('toggle')
                    this.getComments()
                }, 3000)
            },
            formatDate(date) {
                const currentDate = moment()
                const datePosted =  moment(date)
                const differenceInDays = currentDate.diff(datePosted, 'days')
                const differenceInWeeks = Math.floor(differenceInDays / 7)
                return differenceInDays > 7 ?differenceInWeeks + ' week' + (differenceInWeeks > 1 ? 's' : '') + ' ago' : (differenceInDays === 0 ? 'Today' : differenceInDays  + ' days ago')
            },
            changePage(page) {
                if (page === 0) return

                this.page = page
                this.getComments()
            },
            async getComments(initial = false){
                this.loading = true

                if (initial) {
                    this.selectedHashtags = this.jwtHashtags
                    this.selectedProfiles = this.profileIDs
                }

                const params = {
                    filters: {},
                    from: this.dateRange.startDate,
                    to: this.dateRange.endDate,
                    page: this.page,
                    limit: 20
                }

                if (!this.selectedHashtags.length) {
                    params.filters.hashtags = this.jwtHashtags
                } else {
                    params.filters.hashtags = this.selectedHashtags
                }

                params.filters.locations = this.selectedLocations
                params.filters.profileIDs = this.selectedProfiles

                const comments = await InstagramService.comments.index(params)

                this.comments = comments.data
                this.lastPage = comments.lastPage
                this.total = comments.total

                this.loading = false
            },
        },
        async mounted() {
            this.$on('change-page', (index) => {
                this.changePage(index);
            });

            const pageInfo = await InstagramService.pages.get()
            this.canReply = pageInfo.page != null
            this.getComments(true)
            $('[data-toggle="tooltip"]').tooltip()
        }
    }
</script>
